import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";
//UI
import HomeLayout from '../../../layouts/HomeLayout';
import BtnTable from '../../../components/buttons/BtnTable';
import HeaderSimple from '../../../components/headers/catalogs/HeaderSimple';
import MainLoader from '../../../components/Loaders/MainLoader';
import IconStatus from '../../../components/icons/IconStatus';
import Error from '../../../components/errors/Error';
//SLICE
import { deleteUserThunk, getUsersThunk } from '../../../store/slices/catalogs/users.slice';
import BtnAdd from '../../../components/buttons/BtnAdd';


const CompanyUserList = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { users, message, error } = useSelector(state => state.users);
    const isLoading = useSelector(state => state.isLoadingSlice);

    useEffect(() => {
        dispatch(getUsersThunk());
    }, []);

    if (message === "Registro eliminado correctamente") {
        dispatch(getUsersThunk());
    }

    const handledeleteUser = (user_id) => {
        dispatch(deleteUserThunk(user_id));
    };

    return (
        <HomeLayout>
            {isLoading ? (
                <MainLoader />
            ) : (
                <div className='mx-5 my-5 w-full'>
                    {error ? <Error state={error} /> : " "}
                    <div className='flex w-full items-center justify-between p-2 border mb-2 shadow-sm'>
                        <HeaderSimple title={t("user_title")} to={`/panel/users_new`} />
                        <div className='flex gap-2 items-center'>
                            <BtnAdd to={`/panel/users/user_new`} />
                        </div>
                    </div>
                    <div className="h-[90%] flex flex-col  rounded overflow-hidden">
                        <div className="overflow-y-auto flex-1 contenedor">
                            <table className="min-w-full table-zebra table-fixed border-collapse text-[13px] text-left">
                                <thead className="sticky top-0 bg-white">
                                    <tr className='text-left h-[50px] bg-p-orange/80 text-white'>
                                        <th className='w-[25px]'></th>
                                        <th>{t("user_name")}</th>
                                        <th>{t("user_email")}</th>
                                        <th>{t("user_role")}</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {users.map(user => (
                                        <tr className='h-[50px]' key={user.id}>
                                            <td className='p-2'><IconStatus active={user.active} /></td>
                                            <td>{user.first_name} {user.last_name}</td>
                                            <td>{user.email}</td>
                                            <td>{user.rol?.name}</td>
                                            <td>
                                                <div className='flex gap-1 justify-end items-center h-[50px] p-2'>
                                                    <BtnTable action="edit" to={`/panel/users/${user.id}`} />
                                                    <BtnTable title={t("user_delete")} action="delete" onclick={() => handledeleteUser(user.id)} />
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot className="sticky bottom-0 z-10 bg-gray-100 text-gray-700">
                                    <tr>
                                        <td colSpan={6} className="text-right p-2">
                                            Total de registros:{" "}
                                            <span className="text-p-sky text-[18px]">{users?.length ?? 0}</span>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            )}
        </HomeLayout>
    );
};

export default CompanyUserList;